<app-icon-button
  class="transform -rotate-90"
  [type]="'basic'"
  [svgIconPath]="'arrow-single'"
  (click)="backToAllComments()">
</app-icon-button>
